import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import ReactVideoPlayer from "src/components/ReactPlayers/ReactVideoPlayer";
import GrPage from "src/design-system/components/GrPage";
import GrPageHeader from "src/design-system/components/GrPageHeader";
import FeedDetailBody from "./FeedDetailBody";

// Post page (/community-area-post-detail/:id, e.g. from a notification): back arrow to the community
// feed, then the post in one card (FeedDetailBody, shared with the post popup).
export default function FeedDetailPage() {
  const params = useParams();
  const navigate = useNavigate();
  const backToFeed = () => navigate(`/community-area`);

  return (
    <GrPage>
      <GrPageHeader onBack={backToFeed} />
      <FeedDetailBody
        key={params.id}
        postId={params.id}
        layout="page"
        VideoPlayer={ReactVideoPlayer}
        // The post is gone: back to the feed (the snackbar says it was deleted).
        onDeleted={backToFeed}
      />
    </GrPage>
  );
}
